import type { Config } from "./client";
import { config } from "./client";
import { loadShellEnv } from "./loadShellEnv";

export { config, type Config } from "./client";

// We don't care what kind of promise
let shellEnvPromise: Promise<unknown> | null = null;

export async function loadConfig(): Promise<Config> {
  // Some browsers have old versions of the index.html making the cleanup impossible at the moment...
  // So I'm adding back the old env fetching as a fallback while we fix caching issues.
  if (config.SHELL_ENV.CONFIGCAT_SDK_KEY === undefined) {
    if (!shellEnvPromise) {
      shellEnvPromise = loadShellEnv();
    }
    await shellEnvPromise;
  }
  return config;
}
